import React from 'react'
import {Link} from 'react-router-dom'

import Svg from '../Svg'
import htoText from '../../../../svg/home-try-on.svg'
import * as URLS from '../../urls'

import closedBox from '../../../../img/closed-box.jpg'

const HtoBoxImage = <img alt="Home Try-On Box" className="pdp-hto-box" src={closedBox} />

const PdpHto = () => (
  <section className="pdp-hto">
    <div className="pdp-hto-inner">
      <div className="show-for-desktop">
        {HtoBoxImage /* shows next to title and description on desktop */}
      </div>
      <div className="pdp-hto-text">
        <div className="pdp-hto-text-inner">
          <h2 className="pdp-hto-title">
            <span className="u-sr-only">Free Home Try-On</span>
            <Svg className="pdp-hto-title-icon" src={htoText} />
          </h2>
          <div className="hide-for-desktop">
            {HtoBoxImage /* shows between title and description on mobile */}
          </div>
          <div className="pdp-hto-description">
            <p className="pdp-hto-description-text">
              Test drive the quality and fit of our garments with the Home Try-On Program.
            </p>
            <Link className="pdp-hto-description-link" to={URLS.HOME_TRY_ON}>
              Check it Out
            </Link>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default PdpHto
